var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "vertical",
          height: _vm.tabHeight,
          tabItems: _vm.tabItems,
        },
        on: {
          "update:height": function ($event) {
            _vm.tabHeight = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    param: _vm.popupParam,
                    planUpdateBtnData: _vm.popupParam.planUpdateBtnData,
                    educationInfo: _vm.educationInfo,
                  },
                  on: {
                    "update:educationInfo": function ($event) {
                      _vm.educationInfo = $event
                    },
                    "update:education-info": function ($event) {
                      _vm.educationInfo = $event
                    },
                    setData: _vm.setData,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }